"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
require("./recaptcha.scss");
const constants_1 = require("../../constants/constants");
const react_2 = __importDefault(require("react"));
const ElementBaseConfig_1 = require("../../config/ElementBaseConfig");
const Recaptcha = (0, react_1.forwardRef)((props, ref) => {
    const recaptchaRef = (0, react_1.useRef)(null);
    let app_env_local = window.location.origin.match(/localhost/g) ||
        window.location.origin.match(/beta/g)
        ? constants_1.AppEnvironments.dev
        : constants_1.AppEnvironments.prod;
    const recaptchaKey = app_env_local === 2
        ? (0, ElementBaseConfig_1.getElementkitConfig)().recaptchaKey
        : "6LftCPAqAAAAAGAsg7Bji1WFnNYqo9PIA77tY5gV";
    return (react_2.default.createElement(react_google_recaptcha_1.default, { id: "recaptcha", ref: ref || recaptchaRef, size: "invisible", sitekey: recaptchaKey, style: Object.assign({}, props.styles) }));
});
exports.default = Recaptcha;
